<h1 matDialogTitle>WARNING CREATING CREDIT NOTE</h1>

<mat-dialog-content>
    <p>Please review the below warnings before you continue:</p>
    <ol>
      <li *ngFor="let warning of data.warnings">{{warning.warning}}</li>
    </ol>
    <mat-checkbox [(ngModel)]="accepted" value="" color="primary">I have read the warnings and I understand the implications when I proceed with creating this Credit Note</mat-checkbox>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button [matDialogClose]="false">Cancel</button>
    <button mat-button [disabled]="!accepted" [matDialogClose]="true">Create Credit Note</button>
</mat-dialog-actions>
